<template>
    <div class="main partner">
        <div class="head">
            <span style="margin-bottom:.3rem">智慧伊旗农牧大数据平台</span>
        </div>
        <div class="gobcak" @click="goBack"><img src="@/assets/yq/yiqi_back.png" alt=""><span>返回上一层</span></div>
        <div class="prediction">
            <div class="prediction-box" style="display: flex;">
                <div class="prediction-region">
                    <!-- <div class="prediction-region-top">
                        <img src="@/assets/icon-xuhua.png" class="prediction-imge">
                        <span class="font">预警地域分布</span>
                    </div> -->
                    <chartTitle title="预警地域分布"></chartTitle>
                    <div style=" display: flex; width: 100%; height: 100%;">
                        <div id="mapMain" style="width: 10.25rem;height: 6.38rem; "></div>
                        <div class="warning">
                            <div class="fc">
                                <span class="warning-add">今日新增</span>
                                <span class="warning-addNumber">+3</span>
                            </div>
                            <div class="warning-total">预警总数：13</div>
                            <div class="fc" style="width: 100%;">
                                <div style="margin-right: 0.6rem;">
                                    <div class="fc">
                                        <img src="@/assets/预警1.png" class="warning-imge">
                                        <span class="warning-insectfont">虫害预警：</span>
                                        <span style="font-size: 0.3rem;color: #FFF200;">6</span>
                                    </div>
                                    <div class="fc" style="margin: 0.59rem 0 0.38rem 0;">
                                        <img src="@/assets/预警2.png" class="warning-imge">
                                        <span class="warning-insectfont">环境预警：</span>
                                        <span style="font-size: 0.3rem;color: #FFFFFF;">0</span>
                                    </div>
                                </div>
                                <div>
                                    <div class="fc">
                                        <img src="@/assets/预警3.png" class="warning-imge">
                                        <span class="warning-insectfont">天气预警：</span>
                                        <span style="font-size: 0.3rem;color: #FFF200;">0</span>
                                    </div>
                                    <div class="fc" style="margin: 0.59rem 0 0.38rem 0;">
                                        <img src="@/assets/预警4.png" class="warning-imge">
                                        <span class="warning-insectfont">土壤预警：</span>
                                        <span style="font-size: 0.3rem;color: #FFF200;">4</span>
                                    </div>
                                </div>
                            </div>
                            <div class="warning-proportion">
                                <div class="fc">
                                    <img src="@/assets/circle.png">
                                    <span class="warning-proportion-font">本月预警占比分析</span>
                                </div>
                                <div id="chart3" style="width: 5.9rem;height: 2.95rem;"></div>
                            </div>
                        </div>
                    </div>
                </div>


                <div class="prediction-weather">
                    <!-- <div class="prediction-region-top">
                        <img src="@/assets/icon-xuhua.png" class="prediction-imge">
                        <span class="font">天气预报预警</span>
                    </div> -->
                    <chartTitle title="天气预报预警"></chartTitle>
                    <div class="prediction-weather-header">
                        <div class="prediction-weather-header-left">
                            <span class="prediction-weather-header-left-number">{{ now.temp }}℃</span>
                            <div class="prediction-weather-header-left-condition">
                                <!-- <div class="prediction-insect-round"></div> -->
                                <div>
                                    <span style="padding: 0 0.2rem;">{{ now.text }}</span>
                                    <span>{{ now.feels_like }}℃~{{ now.temp }}℃</span>
                                </div>
                            </div>
                        </div>
                        <div class="prediction-weather-header-right">
                            <div style="display: flex;">
                                <div class="trend">
                                    <span>风&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp向</span>
                                    <span>：{{ now.wind_dir }}</span>
                                </div>
                                <div class="trend">
                                    <span>风 &nbsp&nbsp&nbsp&nbsp&nbsp&nbsp力</span>
                                    <span>：{{ now.wind_class }}</span>
                                </div>

                            </div>
                            <div style="display: flex;margin-top: 0.15rem;">
                                <!-- <div class="trend">
                                    <span>舒 适 度</span>
                                    <span>：良好</span>
                                </div> -->
                                <div class="trend">
                                    <span>相对湿度</span>
                                    <span>：{{ now.rh + '%' }}</span>
                                </div>
                                <div class="trend">
                                    <span>时&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp间</span>
                                    <span>：{{ new Date().toLocaleDateString().replace(/\//g, '-') }}</span>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div ref="hygrometer" style="width: 100%;height: 5rem;"></div>
                </div>
            </div>
            <div style="margin: 0.25rem 0; display: flex; justify-content: space-between;">
                <div class="prediction-environment">
                    <!-- <div class="prediction-region-top">
                        <img src="@/assets/icon-xuhua.png" class="prediction-imge">
                        <span class="font">环境预警</span>
                    </div> -->
                    <chartTitle title="环境预警"></chartTitle>
                    <div style="display: flex;">
                        <div class="prediction-environment-left">
                            <div style="position: relative;" class="Dashboard">
                                <div style="position:absolute"> <img src="@/assets/Dashboard.png"
                                        style="width: 2.34rem;height: 2.33rem"></div>
                                <span class="Dashboard-zhiliang">环境质量</span>
                                <span class="Dashboard-you">优</span>
                                <span class="Dashboard-temp">31</span>
                            </div>
                        </div>
                        <div class="prediction-environment-right">
                            <div style="display: flex; align-items: center">
                                <div style="display: flex; align-items: center">
                                    <img src="@/assets/weather1.png" class="prediction-environment-right-imge">
                                    <span class="prediction-environment-right-font">温度：25℃</span>
                                </div>
                                <div style="display: flex; align-items: center;margin-left: 0.8rem;">
                                    <img src="@/assets/weather1.png" class="prediction-environment-right-imge">
                                    <span class="prediction-environment-right-font">湿度：30%~60%</span>
                                </div>
                            </div>
                            <div style="display: flex; align-items: center;margin: 0.25rem 0;">
                                <div style="display: flex; align-items: center;">
                                    <img src="@/assets/weather2.png" class="prediction-environment-right-imge">
                                    <span class="prediction-environment-right-font">风力：70%</span>
                                </div>
                                <div style="display: flex; align-items: center;margin-left: 0.8rem;">
                                    <img src="@/assets/weather3.png" class="prediction-environment-right-imge">
                                    <span class="prediction-environment-right-font">光照：250 lux</span>
                                </div>
                            </div>
                            <div style="display: flex; align-items: center">
                                <img src="@/assets/weather4.png" class="prediction-environment-right-imge">
                                <span class="prediction-environment-right-font">降雨：800~1000ml</span>
                            </div>


                        </div>
                    </div>
                </div>
                <div class="prediction-insect">
                    <!-- <div class="prediction-region-top">
                        <img src="@/assets/icon-xuhua.png" class="prediction-imge">
                        <span class="font">虫害预警</span>
                    </div> -->
                    <chartTitle title="虫害预警"></chartTitle>
                    <div class="f">
                        <dv-active-ring-chart :config="config" style="width:3rem;height:3rem" />

                        <div class="insect"
                            style="display: flex; align-items: center;flex-direction: column; justify-content: center; margin-left: 0.3rem;">
                            <div style="display: flex; align-items: center;">
                                <div class="prediction-insect-round"></div>
                                <span class="prediction-insect-font">草地螟</span>
                                <span class="prediction-insect-font" style="margin: 0.12rem 0.28rem">13%</span>
                                <span class="prediction-insect-font">预警数：1</span>
                            </div>
                            <div style="display: flex; align-items: center;">
                                <div class="prediction-insect-round" style="background: #165DFF;"></div>
                                <span class="prediction-insect-font">红蜘蛛</span>
                                <span class="prediction-insect-font" style="margin: 0.12rem 0.26rem;">30%</span>
                                <span class="prediction-insect-font">预警数：4</span>
                            </div>
                            <div style="display: flex; align-items: center;">
                                <div class="prediction-insect-round" style="background: #14C9C9;"></div>
                                <span class="prediction-insect-font">柳毒蛾</span>
                                <span class="prediction-insect-font" style="margin: 0.12rem 0.26rem;">19%</span>
                                <span class="prediction-insect-font">预警数：2</span>
                            </div>
                            <div style="display: flex; align-items: center;">
                                <div class="prediction-insect-round" style="background: #722ED1;"></div>
                                <span class="prediction-insect-font">蒙古跳甲</span>
                                <span class="prediction-insect-font" style="margin: 0.12rem 0.26rem;">18%</span>
                                <span class="prediction-insect-font">预警数：2</span>
                            </div>
                            <div style="display: flex; align-items: center;">
                                <div class="prediction-insect-round" style="background: #3491FA;"></div>
                                <span class="prediction-insect-font">麦杆蝇</span>
                                <span class="prediction-insect-font" style="margin: 0.12rem 0.26rem;">20%</span>
                                <span class="prediction-insect-font">预警数：3</span>
                            </div>
                        </div>
                    </div>


                </div>
                <div class="prediction-soil">
                    <!-- <div class="prediction-region-top">
                        <img src="@/assets/icon-xuhua.png" class="prediction-imge">
                        <span class="font">土壤预警</span>
                    </div> -->
                    <chartTitle title="土壤预警"></chartTitle>
                    <div style="margin: 0.36rem;">
                        <div style="display: flex; align-items: center;">
                            <div style="display: flex; align-items: center; width: 3rem;">
                                <img src="@/assets/soil1.png" class="prediction-soil-imge">
                                <div class="prediction-soil-item">
                                    <div class="prediction-soil-item-temp">温度</div>
                                    <div class="prediction-soil-item-number">20.5℃</div>
                                </div>
                            </div>
                            <div style="display: flex; align-items: center; width: 3rem;">
                                <img src="@/assets/soil2.png" class="prediction-soil-imge">
                                <div class="prediction-soil-item">
                                    <div class="prediction-soil-item-temp">湿度</div>
                                    <div class="prediction-soil-item-number">60%~80%</div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div style="margin: 0.36rem;">
                        <div style="display: flex; align-items: center;">
                            <div style="display: flex; align-items: center; width: 3rem;">
                                <img src="@/assets/soil3.png" class="prediction-soil-imge">
                                <div class="prediction-soil-item">
                                    <div class="prediction-soil-item-temp">氮含量</div>
                                    <div class="prediction-soil-item-number">0.0046%</div>
                                </div>
                            </div>
                            <div style="display: flex; align-items: center; width: 3rem;">
                                <img src="@/assets/soil4.png" class="prediction-soil-imge">
                                <div class="prediction-soil-item">
                                    <div class="prediction-soil-item-temp">磷含量</div>
                                    <div class="prediction-soil-item-number">0.0046%</div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div style="margin: 0.36rem;">
                        <div style="display: flex; align-items: center;">
                            <div style="display: flex; align-items: center; width: 3rem;">
                                <img src="@/assets/soil5.png" class="prediction-soil-imge">
                                <div class="prediction-soil-item">
                                    <div class="prediction-soil-item-temp">钾含量</div>
                                    <div class="prediction-soil-item-number">0.0046%</div>
                                </div>
                            </div>
                            <div style="display: flex; align-items: center; ">
                                <img src="@/assets/soil6.png" class="prediction-soil-imge">
                                <div class="prediction-soil-item">
                                    <div class="prediction-soil-item-temp">酸碱度</div>
                                    <div class="prediction-soil-item-number">0.0046%</div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

        </div>
    </div>
</template>
<script>


// import option from './index'
import mapJson from '@/assets/map/150627.json'
import { color } from 'highcharts';
import chartTitle from '../../yqScreen/index/components/indexChartItemTitle.vue'

export default {

    data() {
        return {
            data: [
                { value: 1048, name: 'Search Engine' },
                { value: 735, name: 'Direct' },
                { value: 580, name: 'Email' },
                { value: 484, name: 'Union Ads' },
                { value: 300, name: 'Video Ads' }
            ],
            config: {
                // radius: '40%',
                // activeRadius: '45%',
                // lineWidth: 20,
                data: [
                    {
                        name: '',
                        value: 55
                    },
                    {
                        name: '',
                        value: 120
                    },
                    {
                        name: '',
                        value: 78
                    },
                    {
                        name: '',
                        value: 66
                    },
                    {
                        name: '',
                        value: 80
                    }
                ],
                color: ['#F7BA1E', '#165DFF', '#14C9C9', '#722ED1', '#3491FA'],
                digitalFlopStyle: {
                    fontSize: 20
                },
                showOriginValue: true
            },
            now: {},//今日天气
            weekData: [],//星期
            dayData: [],//近七天
            weatherData: [],//近7天天气
            high: [],//最高天气
            low: [],//最低天气
        };
    },
    watch: {},
    components: {
        chartTitle
    },
    created() {
        this.getWeather()
    },
    mounted() {
        this.$nextTick(() => {
            const mapData = [
                // {
                //     name: '纳林陶亥镇',
                //     value: [110.11966302149337, 39.6283242456816],
                // },
            ]
            const regions = [
                // {
                //     name: '红庆河镇',
                //     itemStyle: { color: 'rgba(26, 87, 86, 0.4)' },
                // },
                // {
                //     name: '纳林陶亥镇',
                //     itemStyle: { color: 'rgba(17, 45, 109, 1)' },
                // },
            ]
            this.initMap(mapData, regions)
            this.setEcharts()

        })

    },
    update() {

    },
    methods: {
        // 获取天气
        getWeather() {
            this.$http({
                url: 'screenapp-service/weather/select',
                //请求方式
                method: 'post',
                //传递的参数
                data: {
                    "districtId": 150627,
                },
            }).then(res => {
                const data = res.data
                if (res.data.code === 200) {
                    var weather = JSON.parse(data.result).result
                    console.log(weather);
                    weather.forecasts.forEach((item) => {
                        this.weekData.push(item.week)
                        this.dayData.push(item.date.split('-')[1] + "-" + item.date.split('-')[2])
                        this.weatherData.push(item.text_day)
                        this.high.push(item.high)
                        this.low.push(item.low)
                    })
                    this.now = weather.now
                    this.$nextTick(() => {
                        this.setLiquidfill()
                    })
                } else {
                    // this.$message.error(data);
                }
            }).catch(err => {
                console.log(err);
            })
        },
        goBack() {
            this.$router.go(-1)
        },
        //环形图
        setEcharts() {
            var myChart3 = this.$echarts.init(document.getElementById("chart3"));
            var option = {
                tooltip: {
                    show: false,//防止鼠标移到不需要的数据上弹出label
                    trigger: 'item',
                    formatter: "{a} : {c} ({d}%)"
                },
                color: ['#dc1439', '#e6b600', '#053afe'],
                legend: {
                    orient: 'vertical',
                    top: '26%',
                    left: '55%',
                    itemHeight: 12,//图例的高度
                    itemGap: 20,//图例之间的间距 
                    icon: 'circle',
                    data: ['虫害预警30.2%', '环境预警30.2%', '天气预警30.2%', '土壤预警30.2%'],//图例的名字需要和饼图的name一致，才会显示图例
                    textStyle: {
                        linHeight: 30,
                        fontSize: '0.18rem',
                        color: '#FFFFFF'
                    },
                },
                series: [
                    {
                        name: '虫害预警30.2%',
                        type: 'pie',
                        radius: ['45%', '40%'],//环的位置
                        center: ["30%", "50%"],//饼状图位置
                        label: {
                            normal: {
                                position: 'inner'
                            }
                        },
                        labelLine: {
                            normal: {
                                show: false
                            }
                        },
                        data: [
                            {
                                value: 90, //需要显示的数据
                                itemStyle: {
                                    normal: {
                                        color: '#dc1439'
                                    }
                                }
                            },
                            {
                                value: 10, //不需要显示的数据，颜色设置成和背景一样
                                itemStyle: {
                                    normal: {
                                        color: 'rgba(25,236,255,0.06)'
                                    }
                                }
                            }
                        ]
                    },
                    {
                        name: '天气预警30.2%',
                        type: 'pie',
                        radius: ['50%', '55%'],
                        center: ["30%", "50%"],//饼状图位置
                        label: {
                            normal: {
                                position: 'inner'
                            }
                        },
                        labelLine: {
                            normal: {
                                show: false
                            }
                        },
                        data: [
                            {
                                value: 30,
                                itemStyle: {
                                    normal: {
                                        color: '#e6b600'
                                    }
                                }
                            },
                            {
                                value: 70,
                                itemStyle: {
                                    normal: {
                                        color: 'rgba(25,236,255,0.06)'
                                    }
                                },
                            }
                        ]
                    },
                    {
                        name: '环境预警30.2%',
                        type: 'pie',
                        radius: ['65%', '60%'],
                        center: ["30%", "50%"],//饼状图位置
                        label: {
                            normal: {
                                position: 'inner'
                            }
                        },
                        labelLine: {
                            normal: {
                                show: false
                            }
                        },
                        data: [
                            {
                                value: 80,
                                itemStyle: {
                                    normal: {
                                        color: '#053afe'
                                    }
                                }
                            },
                            {
                                value: 20,
                                itemStyle: {
                                    normal: {
                                        color: 'rgba(25,236,255,0.06)'
                                    }
                                }
                            }
                        ]


                    },
                    {
                        name: '土壤预警30.2%',
                        type: 'pie',
                        radius: ['75%', '70%'],
                        center: ["30%", "50%"],//饼状图位置
                        label: {
                            normal: {
                                position: 'inner'
                            }
                        },
                        labelLine: {
                            normal: {
                                show: false
                            }
                        },
                        data: [
                            {
                                value: 80,
                                itemStyle: {
                                    normal: {
                                        color: '#14C9C9'
                                    }
                                }
                            },
                            {
                                value: 20,
                                itemStyle: {
                                    normal: {
                                        color: 'rgba(25,236,255,0.06)'
                                    }
                                }
                            }
                        ]
                    }
                ]
            }
            myChart3.setOption(option);
        },


        // 地图
        setLiquidfill() {
            var one = this.weatherData[0]
            var two = this.weatherData[1]
            var three = this.weatherData[2]
            var four = this.weatherData[3]
            var five = this.weatherData[4]
            const hygrometer = this.$echarts.init(this.$refs.hygrometer);
            var option = {
                grid: {
                    show: true,
                    backgroundColor: 'transparent',
                    opacity: 0.3,
                    borderWidth: '0',
                    top: '180',
                    bottom: '5%'
                },
                tooltip: {
                    trigger: 'axis'
                },
                legend: {
                    show: false
                },
                xAxis: [
                    // 日期
                    {
                        type: 'category',
                        boundaryGap: false,
                        position: 'top',
                        offset: 130,
                        zlevel: 100,
                        axisLine: {
                            show: false
                        },
                        axisTick: {
                            show: false
                        },
                        axisLabel: {
                            interval: 0,
                            formatter: [
                                '{a|{value}}'
                            ].join('\n'),
                            rich: {
                                a: {
                                    color: '#FDFDFD',
                                    fontSize: 10
                                }
                            }
                        },
                        nameTextStyle: {

                        },
                        data: this.weekData
                    },
                    // 星期
                    {
                        type: 'category',
                        boundaryGap: false,
                        position: 'top',
                        offset: 110,
                        zlevel: 100,
                        axisLine: {
                            show: false
                        },
                        axisTick: {
                            show: false
                        },
                        axisLabel: {
                            interval: 0,
                            formatter: [
                                '{a|{value}}'
                            ].join('\n'),
                            rich: {
                                a: {
                                    color: '#FDFDFD',
                                    fontSize: 14
                                }
                            }
                        },
                        nameTextStyle: {
                            fontWeight: 'bold',
                            fontSize: 19
                        },
                        data: this.dayData
                    },
                    // 天气图标
                    {
                        type: 'category',
                        boundaryGap: false,
                        position: 'top',
                        offset: 20,
                        zlevel: 100,
                        axisLine: {
                            show: false
                        },
                        axisTick: {
                            show: false
                        },
                        axisLabel: {
                            interval: 0,
                            formatter: function (value, index) {
                                return '{' + index + '| }\n{b|' + value + '}'
                            },
                            rich: {
                                0: {
                                    backgroundColor: {
                                        // image: require('@/assets/weather_icon/' + this.weatherIconDic[this.weatherdata.weather[0]] + '.png')
                                        image: `https://d.scggqx.com/forecast/img/${one}.png`
                                    },
                                    height: 30,
                                    width: 30
                                },
                                1: {
                                    backgroundColor: {
                                        // image: require('@/assets/weather_icon/' + this.weatherIconDic[this.weatherdata.weather[1]] + '.png')
                                        image: `https://d.scggqx.com/forecast/img/${two}.png`
                                    },
                                    height: 30,
                                    width: 30
                                },
                                2: {
                                    backgroundColor: {
                                        // image: require('@/assets/weather_icon/' + this.weatherIconDic[this.weatherdata.weather[2]] + '.png')
                                        image: `https://d.scggqx.com/forecast/img/${three}.png`
                                    },
                                    height: 30,
                                    width: 30
                                },
                                3: {
                                    backgroundColor: {
                                        // image: require('@/assets/weather_icon/' + this.weatherIconDic[this.weatherdata.weather[3]] + '.png')
                                        image: `https://d.scggqx.com/forecast/img/${four}.png`
                                    },
                                    height: 30,
                                    width: 30
                                },
                                4: {
                                    backgroundColor: {
                                        // image: require('@/assets/weather_icon/' + this.weatherIconDic[this.weatherdata.weather[4]] + '.png')
                                        image: `https://d.scggqx.com/forecast/img/${five}.png`
                                    },
                                    height: 30,
                                    width: 30
                                },
                                // 5: {
                                //     backgroundColor: {
                                //         // image: require('@/assets/weather_icon/' + this.weatherIconDic[this.weatherdata.weather[5]] + '.png')
                                //         image: 'https://d.scggqx.com/forecast/img/小雨.png'
                                //     },
                                //     height: 30,
                                //     width: 30
                                // },
                                // 6: {
                                //     backgroundColor: {

                                //         // image: require('@/assets/weather_icon/' + this.weatherIconDic[this.weatherdata.weather[6]] + '.png')
                                //         image: 'https://d.scggqx.com/forecast/img/小雨.png'
                                //     },
                                //     height: 30,
                                //     width: 30
                                // },
                                b: {
                                    color: '#FDFDFD',
                                    fontSize: 12,
                                    lineHeight: 30,
                                    height: 20
                                }
                            }
                        },
                        nameTextStyle: {
                            fontWeight: 'bold',

                            fontSize: 19
                        },
                        // data: this.weatherdata.weather
                        data: this.weatherData
                    }
                ],
                yAxis: {
                    type: 'value',
                    show: false,
                    axisLabel: {
                        formatter: '{value} °C',
                        color: 'white'
                    }
                },
                series: [
                    {
                        name: '最高气温',
                        type: 'line',
                        data: this.high,
                        symbol: 'emptyCircle',
                        symbolSize: 8,
                        showSymbol: true,
                        smooth: false,
                        itemStyle: {
                            normal: {
                                color: '#FFFFFF'
                            }
                        },
                        label: {
                            show: true,
                            position: 'top',
                            color: 'white',
                            formatter: '{c} °C'
                        },
                        lineStyle: {
                            width: 1,
                            color: '#0AA7FF'
                        },
                        areaStyle: {
                            opacity: 1,
                            color: 'transparent'
                        }
                    },
                    {
                        name: '最低气温',
                        type: 'line',
                        data: this.low,
                        symbol: 'emptyCircle',
                        symbolSize: 10,
                        showSymbol: true,
                        smooth: false,
                        itemStyle: {
                            normal: {
                                color: 'blue'
                            }
                        },
                        label: {
                            show: true,
                            position: 'bottom',
                            color: 'white',
                            formatter: '{c} °C'
                        },
                        lineStyle: {
                            width: 1,
                            color: 'white'
                        },
                        areaStyle: {
                            width: 1,
                            opacity: 1,
                            color: 'transparent'
                        }
                    }
                ]
            }
            hygrometer.setOption(option);

        },
        initMap(data, regions) {
            const _this = this
            // 基于准备好的dom，初始化echarts实例
            var chart = this.$echarts.init(document.getElementById('mapMain'))

            this.$echarts.registerMap('bayannaoer', mapJson)
            // 隐藏动画加载效果。
            chart.hideLoading()

            let cahrtOption = {
                geo3D: {
                    type: 'map3D', // 系列类型
                    name: 'map3D', // 系列名称
                    map: 'bayannaoer',
                    boxHeight: 4,
                    zoom: 1,
                    label: {
                        // 标签的相关设置
                        show: false, // (地图上的城市名称)是否显示标签 [ default: false ]
                        //distance: 50, // 标签距离图形的距离，在三维的散点图中这个距离是屏幕空间的像素值，其它图中这个距离是相对的三维距离
                        //formatter:, // 标签内容格式器
                        textStyle: {
                            // 标签的字体样式
                            color: '#000', // 地图初始化区域字体颜色
                            fontSize: 8, // 字体大小
                            opacity: 1, // 字体透明度
                            backgroundColor: 'rgba(0,23,11,0)', // 字体背景色
                        },
                    },

                    itemStyle: {
                        // 三维地理坐标系组件 中三维图形的视觉属性，包括颜色，透明度，描边等。
                        color: 'rgba(51, 119, 171, 0.3)', // 地图板块的颜色
                        opacity: 1, // 图形的不透明度 [ default: 1 ]
                        borderWidth: 2, // (地图板块间的分隔线)图形描边的宽度。加上描边后可以更清晰的区分每个区域 [ default: 0 ]
                        borderColor: 'rgba(111,202,242, 0.8)', // 图形描边的颜色。[ default: #333 ]
                    },

                    emphasis: {
                        // 鼠标 hover 高亮时图形和标签的样式 (当鼠标放上去时 label和itemStyle 的样式)
                        label: {
                            // label高亮时的配置
                            show: false,
                            textStyle: {
                                color: '#fff', // 高亮时标签颜色变为 白色
                                fontSize: 15, // 高亮时标签字体 变大
                            },
                            borderColor: '#08DAC8',
                            borderWidth: 2,
                            padding: 5,
                            backgroundColor: 'red',
                            extraCssText: 'box-shadow: rgba(47, 244, 225, 0.5) 0px 0px 10px;',
                            formatter: function (params) {
                                return ''
                            },
                        },
                    },

                    groundPlane: {
                        // 地面可以让整个组件有个“摆放”的地方，从而使整个场景看起来更真实，更有模型感。
                        show: false, // 是否显示地面。[ default: false ]
                    },
                    light: {
                        // 光照相关的设置。在 shading 为 'color' 的时候无效。 光照的设置会影响到组件以及组件所在坐标系上的所有图表。合理的光照设置能够让整个场景的明暗变得更丰富，更有层次。
                        main: {
                            // 场景主光源的设置，在 globe 组件中就是太阳光。
                            color: '#fff', //主光源的颜色。[ default: #fff ]
                            intensity: 1.2, //主光源的强度。[ default: 1 ]
                            shadow: false, //主光源是否投射阴影。默认关闭。 开启阴影可以给场景带来更真实和有层次的光照效果。但是同时也会增加程序的运行开销。
                            shadowQuality: 'high', // 阴影的质量。可选'low', 'medium', 'high', 'ultra' [ default: 'medium' ]
                            alpha: 55, // 主光源绕 x 轴，即上下旋转的角度。配合 beta 控制光源的方向。[ default: 40 ]
                            beta: 10, // 主光源绕 y 轴，即左右旋转的角度。[ default: 40 ]
                        },
                    },

                    viewControl: {
                        // 用于鼠标的旋转，缩放等视角控制。
                        projection: 'orthographic', // 投影方式，默认为透视投影'perspective'，也支持设置为正交投影'orthographic'。
                        autoRotate: false, // 是否开启视角绕物体的自动旋转查看。[ default: false ]
                        autoRotateDirection: 'cw', // 物体自传的方向。默认是 'cw' 也就是从上往下看是顺时针方向，也可以取 'ccw'，既从上往下看为逆时针方向。
                        autoRotateSpeed: 10, // 物体自传的速度。单位为角度 / 秒，默认为10 ，也就是36秒转一圈。
                        autoRotateAfterStill: 3, // 在鼠标静止操作后恢复自动旋转的时间间隔。在开启 autoRotate 后有效。[ default: 3 ]
                        damping: 0, // 鼠标进行旋转，缩放等操作时的迟滞因子，在大于等于 1 的时候鼠标在停止操作后，视角仍会因为一定的惯性继续运动（旋转和缩放）。[ default: 0.8 ]
                        rotateSensitivity: 1, // 旋转操作的灵敏度，值越大越灵敏。支持使用数组分别设置横向和纵向的旋转灵敏度。默认为1, 设置为0后无法旋转。 rotateSensitivity: [1, 0]——只能横向旋转； rotateSensitivity: [0, 1]——只能纵向旋转。
                        zoomSensitivity: 1, // 缩放操作的灵敏度，值越大越灵敏。默认为1,设置为0后无法缩放。
                        panSensitivity: 1, // 平移操作的灵敏度，值越大越灵敏。默认为1,设置为0后无法平移。支持使用数组分别设置横向和纵向的平移灵敏度
                        panMouseButton: 'left', // 平移操作使用的鼠标按键，支持：'left' 鼠标左键（默认）;'middle' 鼠标中键 ;'right' 鼠标右键(注意：如果设置为鼠标右键则会阻止默认的右键菜单。)
                        rotateMouseButton: 'left', // 旋转操作使用的鼠标按键，支持：'left' 鼠标左键;'middle' 鼠标中键（默认）;'right' 鼠标右键(注意：如果设置为鼠标右键则会阻止默认的右键菜单。)
                        orthographicSize: 65,
                        distance: 200, // [ default: 100 ] 默认视角距离主体的距离，对于 grid3D 和 geo3D 等其它组件来说是距离中心原点的距离,对于 globe 来说是距离地球表面的距离。在 projection 为'perspective'的时候有效。
                        minDistance: 40, // [ default: 40 ] 视角通过鼠标控制能拉近到主体的最小距离。在 projection 为'perspective'的时候有效。
                        maxDistance: 400, // [ default: 400 ] 视角通过鼠标控制能拉远到主体的最大距离。在 projection 为'perspective'的时候有效。

                        alpha: 40, // 视角绕 x 轴，即上下旋转的角度。配合 beta 可以控制视角的方向。[ default: 40 ]
                        beta: 15, // 视角绕 y 轴，即左右旋转的角度。[ default: 0 ]
                        minAlpha: -45, // 上下旋转的最小 alpha 值。即视角能旋转到达最上面的角度。[ default: 5 ]
                        maxAlpha: 45, // 上下旋转的最大 alpha 值。即视角能旋转到达最下面的角度。[ default: 90 ]
                        minBeta: -45, // 左右旋转的最小 beta 值。即视角能旋转到达最左的角度。[ default: -80 ]
                        maxBeta: 45, // 左右旋转的最大 beta 值。即视角能旋转到达最右的角度。[ default: 80 ]

                        center: [0, 0, 0], // 视角中心点，旋转也会围绕这个中心点旋转，默认为[0,0,0]。

                        animation: true, // 是否开启动画。[ default: true ]
                        animationDurationUpdate: 1000, // 过渡动画的时长。[ default: 1000 ]
                        animationEasingUpdate: 'cubicInOut', // 过渡动画的缓动效果。[ default: cubicInOut ]
                    },
                    regions: regions,
                },
                series: [
                    {
                        // 地图类型。echarts-gl 中使用的地图类型同 geo 组件相同(ECharts 中提供了两种格式的地图数据，一种是可以直接 script 标签引入的 js 文件，引入后会自动注册地图名字和数据。还有一种是 JSON 文件，需要通过 AJAX 异步加载后手动注册。)
                        type: 'scatter3D',
                        coordinateSystem: 'geo3D',
                        symbol: 'image://' + require('@/assets/预警1.png'),
                        symbolSize: 20,
                        itemStyle: {
                            normal: {
                                // borderColor:'#FF8400',
                                color: '#F2FF00FF',
                            },
                            effect: {
                                show: true,
                                shadowBlur: 10,
                                loop: true
                            },

                        },
                        data: [
                            {
                                name: '纳林陶亥镇',
                                value: [110.01666302149337, 39.6283242456816, 100],
                            },
                            {
                                name: '纳林陶亥镇',
                                value: [109.74652060957247, 39.49194198364336, 110],
                            },
                            {
                                name: '红庆河镇',
                                value: [109.37305019089168, 39.43146024913993,],
                            },

                            {
                                name: '红庆河镇',
                                value: [109.63368711988757, 39.635118211159,],
                            },
                            {
                                name: '红庆河镇',
                                value: [109.84912170340222, 39.50674841166803],
                            },
                            {
                                name: '红庆河镇',
                                value: [109.99333118611193, 39.53926770577715],
                            },

                        ],
                    },

                    {
                        // 地图类型。echarts-gl 中使用的地图类型同 geo 组件相同(ECharts 中提供了两种格式的地图数据，一种是可以直接 script 标签引入的 js 文件，引入后会自动注册地图名字和数据。还有一种是 JSON 文件，需要通过 AJAX 异步加载后手动注册。)
                        type: 'scatter3D',
                        coordinateSystem: 'geo3D',
                        symbolSize: 20,
                        symbol:
                            'path://M23,0C23.6627,0,24.2,0.537258,24.2,1.2C24.2,1.86274,23.6627,2.4,23,2.4C18.15085,2.40008,14.06293,6.01594,13.4708,10.8288C13.556000000000001,10.8072,13.6388,10.7952,13.7132,10.7916C14.5496,10.7436,15.164,11.1468,15.5564,12L16.982,12C17.648,11.2068,18.4904,10.8204,19.5104,10.8408C20.418799999999997,10.86,21.1952,11.2464,21.8408,12L23.768,12C24.2108,10.992,24.791600000000003,10.488,25.5104,10.488C26.3792,10.488,27.0428,10.992,27.5024,12L28.4504,12C29.3048,10.4004,30.2936,9.6,31.4144,9.6C32.5352,9.6,33.4928,10.4004,34.288399999999996,12L35,12C35,18.6276,29.6276,24,23,24C16.3724,24,11,18.6276,11,12C11,5.3724,16.3724,0,23,0ZM17,9.6C16.33726,9.6,15.8,9.06274,15.8,8.4C15.8,7.73726,16.33726,7.2,17,7.2C17.66274,7.2,18.2,7.73726,18.2,8.4C18.2,9.06274,17.66274,9.6,17,9.6ZM26,9.6C25.668599999999998,9.6,25.4,9.33137,25.4,9C25.4,8.66863,25.668599999999998,8.4,26,8.4C26.331400000000002,8.4,26.6,8.66863,26.6,9C26.6,9.33137,26.331400000000002,9.6,26,9.6ZM22.4,10.8C22.0686,10.8,21.8,10.5314,21.8,10.2C21.8,9.86863,22.0686,9.6,22.4,9.6C22.7314,9.6,23,9.86863,23,10.2C23,10.5314,22.7314,10.8,22.4,10.8ZM21.2,7.2C20.20589,7.2,19.4,6.39411,19.4,5.4C19.4,4.40589,20.20589,3.6,21.2,3.6C22.1941,3.6,23,4.40589,23,5.4C23,6.39411,22.1941,7.2,21.2,7.2Z',
                        itemStyle: {
                            normal: {
                                color: '#FF5100FF',
                                areaColor: {
                                    // repeat: 'repeat',
                                },
                            },
                        },
                        data: [
                            {
                                name: '红庆河镇',
                                value: [109.96052917422105, 39.55607649904151],
                            },

                            {
                                name: '红庆河镇',
                                value: [109.48529833729624, 39.49934414691005],
                            },
                            {
                                name: '纳林陶亥镇',
                                value: [109.79558076556464, 39.692848422606716],
                            },
                            {
                                name: '红庆河镇',
                                value: [109.93677031857868, 39.52449428415719],
                            },



                        ],
                    },
                ],
            }
            chart.setOption(cahrtOption)
        },
    },
};
</script>
<style lang="scss">
.prediction {
    .dv-active-ring-chart .active-ring-info .active-ring-name {
        display: none !important;
    }

}
</style>
<style lang="scss" scoped>
.f {
    display: flex;

    .insect {

        .prediction-insect-font {
            min-width: .8rem;
            margin-left: .1rem;
        }
    }
}

.fc {
    display: flex;
    align-items: center;
}

.warningFont {
    font-size: 0.18rem;
    font-family: Source Han Sans CN-Regular, Source Han Sans CN;
    font-weight: 400;
    color: #FFFFFF;
}

.pieChart {
    margin-top: 10px;
    width: 19.32rem;
    height: 10.86rem
}

.main {
    .font {
        font-size: 0.28rem;
        font-family: Source Han Sans CN-Medium, Source Han Sans CN;
        font-weight: 500;
        color: #FFFFFF;
    }

    .Dashboard {
        width: 2.34rem;
        height: 2.33rem;
        margin-left: 0.4rem;
        margin-top: 0.45rem;

        &-Dashboard {
            font-size: 0.38rem;
            font-family: Source Han Sans CN-Medium, Source Han Sans CN;
            font-weight: 500;
            color: #00FF34;
        }

        &-zhiliang {
            top: 1.8rem;
            left: 0;
            right: 0;
            margin: 0 auto;
            position: absolute;
            font-size: 0.15rem;
            font-family: Source Han Sans CN-Regular, Source Han Sans CN;
            font-weight: 400;
            color: #FFFFFF;
            text-align: center;
        }

        &-you {
            top: 2.225rem;
            left: 0.93rem;
            position: absolute;
            font-size: 0.38rem;
            font-family: Source Han Sans CN-Medium, Source Han Sans CN;
            font-weight: 500;
            color: #00FF34;
        }

        &-temp {
            position: absolute;
            top: 1.12rem;
            left: 0.98rem;
            font-size: 0.38rem;
            font-family: Impact-Regular, Impact;
            font-weight: 400;
            color: #FFFFFF;
        }
    }

    width: 24rem;
    // height: 13.5rem;
    min-height: 100vh;
    margin: 0 auto;
    background-size: 100% 100%;
    display: flex;
    flex-direction: column;


    .head {
        display: flex;
        justify-content: center;
        align-items: center;
        width: 100%;
        height: 1.2rem;
        background: url('../../../assets/yq/head_index_bg.png');
        background-size: 100% 100%;
        font-size: 0.55rem;
        font-family: AlibabaPuHuiTi-Bold, AlibabaPuHuiTi;
        font-weight: 700;
        color: #FFFFFF;
        letter-spacing: 5px;
    }

    .gobcak {
        margin-left: 0.25rem;
        left: 0.25rem;
        font-size: .2rem;
        font-family: HarmonyOS Sans SC-Regular, HarmonyOS Sans SC;
        font-weight: 400;
        color: #FDFDFD;
        display: flex;
        align-items: center;
        cursor: pointer;
        width: 3rem;

        img {
            width: .3rem;
            height: .3rem;
        }

        span {
            margin-left: .05rem;
        }
    }

}

.background {
    background: linear-gradient(180deg, rgba(11, 40, 106, 0.6) 0%, rgba(11, 40, 106, 0.19) 47%, rgba(11, 40, 106, 0.62) 100%);
    opacity: 0.94;
}

.prediction {
    margin: 0.25rem;

    &-imge {
        margin: 0 .28rem 0 .11rem;
        width: 0.25rem;
        height: 0.25rem;
    }

    &-region {
        display: inline-block;
        margin-right: .25rem;
        width: 16.35rem;
        height: 7.38rem;
        @extend .background;

        &-top {
            display: flex;
            align-items: center;
            width: 100%;
            height: 0.5rem;
            background: rgba(25, 236, 255, 0.06);
            border-radius: 0.05rem 0.05rem 0rem 0rem;
            opacity: 1;
        }
    }

    // 天气预报
    &-weather {
        display: inline-block;
        width: 6.88rem;
        height: 7.38rem;
        @extend .background;

        &-header {
            display: flex;
            justify-content: space-between;
            box-sizing: border-box;
            margin: 0.25rem;
            padding: 0.2rem 0.1rem;
            width: 6.35rem;
            height: 1.27rem;
            background: linear-gradient(154deg, #0B286A 0%, rgba(11, 40, 106, 0.19) 57%, #0B286A 100%);
            opacity: 0.94;
            border-radius: 0.06rem 0.06rem 0.06rem 0.06rem;

            &-left {
                display: flex;
                flex-direction: column;

                &-number {
                    margin-top: 0.08rem;
                    font-size: 0.38rem;
                    font-family: Source Han Sans CN-Bold, Source Han Sans CN;
                    font-weight: 700;
                    color: #FFFFFF;
                }

                &-condition {
                    display: flex;
                    align-items: center;
                    margin-top: 0.38rem;
                    font-size: 0.18rem;
                    font-family: Source Han Sans CN-Regular, Source Han Sans CN;
                    font-weight: 400;
                    color: #FEFEFE;
                }
            }

            &-right {
                margin-top: 0.41rem;

                .trend {
                    width: 1.65rem;
                    height: 0.15rem;
                    ;
                    line-height: 0.15rem;
                    ;
                    font-size: 0.15rem;
                    font-family: Source Han Sans CN-Regular, Source Han Sans CN;
                    font-weight: 400;
                    color: #FEFEFE;
                }
            }
        }
    }

    &-environment {
        width: 8.05rem;
        height: 3.85rem;
        @extend .background;

        &-right {
            margin-left: 0.41rem;
            margin-top: 0.9rem;

            &-imge {
                width: 0.3rem;
                height: 0.3rem;
                margin-right: 0.3rem;
            }

            &-font {
                font-size: 0.18rem;
                font-family: Source Han Sans CN-Regular, Source Han Sans CN;
                font-weight: 400;
                color: #FFFFFF;
            }
        }
    }

    &-insect {
        width: 8.05rem;
        height: 3.85rem;
        @extend .background;

        &-round {
            width: 0.1rem;
            height: 0.1rem;
            background: #F7BA1E;
            border-radius: 1.25rem 1.25rem 1.25rem 1.25rem;
        }

        &-font {
            font-size: 0.18rem;
            font-family: Source Han Sans CN-Regular, Source Han Sans CN;
            font-weight: 400;
            color: #FFFFFF;
        }
    }

    &-soil {
        width: 6.88rem;
        height: 3.85rem;
        @extend .background;

        &-imge {
            width: 0.6rem;
            height: 0.6rem;
        }

        &-item {
            margin-left: 0.21rem;
            color: #FFFFFF;

            &-temp {
                font-family: Source Han Sans CN-Regular, Source Han Sans CN;
                font-weight: 400;
            }

            &-number {
                margin-top: 0.14rem;
                font-size: 0.2rem;
                font-family: Impact-Regular, Impact;
                font-weight: 500;
            }
        }
    }

    .warning {
        margin: 0.44rem 0.64rem;

        &-imge {
            width: 0.59rem;
            height: 0.41rem;
            margin-right: 0.14rem;
        }

        &-add {
            margin-right: 0.23rem;
            @extend .warningFont;
        }

        &-addNumber {
            font-size: 0.33rem;
            font-family: Impact-Regular, Impact;
            font-weight: 400;
            color: #FFF200;
        }

        &-total {
            margin: 0.26rem 0 0.49rem 0;
            @extend .warningFont;
        }

        &-insectfont {
            @extend .warningFont;
            margin-right: 0.16rem;
        }

        &-proportion {
            &-font {
                font-size: 0.25rem;
                font-family: Source Han Sans CN-Bold, Source Han Sans CN;
                font-weight: 700;
                color: #FFFFFF;
            }
        }
    }
}

.cursor {
    cursor: pointer;
}
</style>